module.exports = __webpack_public_path__ + "static/images/rabbit.08fe011.png";